import React from 'react';
import ReportsTable from './ReportsTable/ReportsTable';
import { Box, IconButton, Stack, Tab, Tabs, Typography } from '@mui/material';
import { getPolyglot } from '../../i18n';
import ReportScheduleList from './ReportSchedule/ReportScheduleList';
import { useLocation } from 'react-router-dom';
import { AddIcon } from '../../theme/icons';
import useStateBoolean from '../../util/hooks/useStateBoolean';
import ModalEditCreateReportSchedule from './ReportSchedule/EditReportSchedule/ModalEditCreateReportSchedule';
import {
  DefaultAdaptableParams,
  useAdaptableParams,
} from '../../util/hooks/useAdaptableParams';
import ModalCreateReport from './ReportsTable/CreateReport/ModalCreateReport';

enum TABS_REPORTS {
  reports = 'list',
  reportsSettings = 'settings',
}

function Reports() {
  const polyglot = getPolyglot();
  const location = useLocation();

  const params = useAdaptableParams<DefaultAdaptableParams>();
  const { merchandiseId } = params;
  let { groupId } = params;
  groupId = groupId ?? merchandiseId;

  // Get tab from path param (e.g. /reports/:tab)
  const tabFromPath = location.pathname.split('/').pop() as TABS_REPORTS;
  const validTabs = [TABS_REPORTS.reports, TABS_REPORTS.reportsSettings];
  const initialTab = validTabs.includes(tabFromPath)
    ? tabFromPath
    : TABS_REPORTS.reports;
  const [valueTab, setValueTab] = React.useState(initialTab);

  React.useEffect(() => {
    if (tabFromPath !== valueTab) {
      setValueTab(
        tabFromPath && validTabs.includes(tabFromPath)
          ? tabFromPath
          : TABS_REPORTS.reports
      );
    }
  }, [tabFromPath]);

  const [
    isOpenEditScheduleSettings,
    openEditScheduleSettings,
    closeEditScheduleSettings,
  ] = useStateBoolean(false);

  const [isOpenCreateReport, openCreateReport, closeCreateReport] =
    useStateBoolean(false);

  const handleTabChange = (_event: any, newValue: TABS_REPORTS) => {
    setValueTab(newValue);
  };

  const onClickCreate = () => {
    valueTab === TABS_REPORTS.reports
      ? openCreateReport()
      : openEditScheduleSettings();
  };

  return (
    <div>
      <Box
      // sx={{
      //   borderBottom: 1,
      //   borderColor: 'divider',
      // }}
      >
        <Stack
          direction="row"
          spacing={2}
          alignItems="baseline"
          justifyContent="space-between"
        >
          {valueTab === TABS_REPORTS.reports && (
            <Box sx={{ paddingY: 2 }}>
              <Typography variant="h2">
                {polyglot.t('reports.reports')}
              </Typography>
              <Typography variant="body1">
                {polyglot.t('reports.reports_description')}
              </Typography>
            </Box>
          )}
          {valueTab === TABS_REPORTS.reportsSettings && (
            <Box sx={{ paddingY: 2 }}>
              <Typography variant="h2">
                {polyglot.t('reports.schedule.title')}
              </Typography>
              <Typography variant="body1">
                {polyglot.t('reports.schedule.description')}
              </Typography>
            </Box>
          )}

          <IconButton onClick={onClickCreate}>
            <AddIcon />
          </IconButton>
        </Stack>
        {/* <Tabs
          value={valueTab}
          onChange={handleTabChange}
          aria-label="filter request tabs"
          variant="scrollable"
          allowScrollButtonsMobile
        >
          <Tab
            label={polyglot.t('reports.reports')}
            aria-controls={'filter-tab-panel-all-request'}
            value={TABS_REPORTS.reports}
          />
          <Tab
            label={polyglot.t('reports.schedule.title')}
            aria-controls={'filter-tab-panel-in-progress'}
            value={TABS_REPORTS.reportsSettings}
          />
        </Tabs> */}
      </Box>
      {valueTab === TABS_REPORTS.reports && (
        <Box sx={{ paddingY: 2 }}>
          <ReportsTable groupId={groupId} />
        </Box>
      )}
      {valueTab === TABS_REPORTS.reportsSettings && (
        <Box sx={{ paddingY: 2 }}>
          <ReportScheduleList />
        </Box>
      )}
      <ModalEditCreateReportSchedule
        open={isOpenEditScheduleSettings}
        onClose={closeEditScheduleSettings}
        groupId={groupId}
      />
      <ModalCreateReport
        open={isOpenCreateReport}
        onClose={closeCreateReport}
        groupId={groupId}
      />
    </div>
  );
}

export default Reports;
